import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { Calendar, ArrowRight } from 'lucide-react';
import { blogPosts } from '../data/mock';
import { stripDiacritics } from '../lib/utils';

const Blog = () => {
  return (
    <section id="blog" className="py-24 bg-[#0A192F]">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-[#F2F2F2] mb-4">
            Consejos y guías para sacar el máximo partido a tu{' '}
            <span className="text-[#FFD700]">toldo</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {blogPosts.map((post) => (
            <div
              key={post.id}
              className="bg-[#F2F2F2]/5 rounded-xl overflow-hidden hover:bg-[#F2F2F2]/10 transition-all group"
            >
              <div
                className="relative overflow-hidden"
                style={{ aspectRatio: '16 / 9' }}
              >
                <img
                  src={post.image}
                  alt={stripDiacritics(post.title)}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="p-6">
                <div className="flex items-center gap-2 text-[#FFD700] mb-3">
                  <Calendar className="w-4 h-4" />
                  <span className="text-sm">{new Date(post.date).toLocaleDateString('es-ES')}</span>
                </div>
                <h3 className="text-xl font-bold text-[#F2F2F2] mb-3">{post.title}</h3>
                <p className="text-[#F2F2F2]/70 mb-4">{post.excerpt}</p>
                <Link
                  to={`/blog/${post.slug}`}
                  className="text-[#FFD700] font-semibold flex items-center gap-2 hover:gap-3 transition-all"
                >
                  Leer más
                  <ArrowRight className="w-4 h-4" />
                </Link>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Button
            asChild
            className="bg-[#FFD700] text-[#0A192F] hover:bg-[#FFD700]/90 font-semibold px-8 py-6"
          >
            <Link to="/blog">Ver todos los artículos</Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Blog;

